import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAllBlogs } from '../api/blogs';

// Page liste des blogs — données dynamiques depuis le backend
function Blogs() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAllBlogs()
            .then(data => {
                setBlogs(data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    if (loading) return <p className="text-center py-16 text-gray-400">Chargement...</p>;

    return (
        <section className="max-w-4xl mx-auto px-8 py-16">
            <h1 className="text-4xl font-bold mb-10">Blog</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {blogs.map(blog => (
                    <Link to={`/blogs/${blog.id}`} key={blog.id} className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-blue-500 transition block">
                        <p className="text-sm text-gray-500 mb-2">{new Date(blog.created_at).toLocaleDateString()}</p>
                        <h3 className="text-lg font-bold mb-2">{blog.title}</h3>
                        <p className="text-gray-400 text-sm">{blog.content.substring(0, 100)}...</p>
                        {blog.user_name && <p className="text-xs text-gray-600 mt-3">Par {blog.user_name}</p>}
                    </Link>
                ))}
            </div>
        </section>
    );
}

export default Blogs;